import type { TOC } from '@ember/component/template-only';

import styles from './group.module.css';

interface GeneralCurrencyPickerGroupSignature {
  Args: {
    label: string;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

const GeneralCurrencyPickerGroup = <template>
  <div class={{styles.group}} ...attributes>
    <span class="text-300--bold text-neutral-emphasis px-300 pt-400 pb-200">
      {{@label}}
    </span>

    {{yield}}
  </div>
</template> satisfies TOC<GeneralCurrencyPickerGroupSignature>;

export default GeneralCurrencyPickerGroup;
